module.exports = __webpack_public_path__ + "img/modelug_8.2fd2df87.png";